import { useQuery } from '@tanstack/react-query';
import { getPhotoUrls, type Photo } from '../../lib/api';

/** Signed URLs for a note's photos. They last 6–12 hours; refresh well before that. */
export function usePhotoUrls(photos: Photo[]) {
  const ids = photos.map((p) => p.id);
  return useQuery({
    queryKey: ['photo-urls', ...ids],
    queryFn: () => getPhotoUrls(ids),
    enabled: ids.length > 0,
    staleTime: 4 * 60 * 60 * 1000,
    gcTime: 5 * 60 * 60 * 1000,
  });
}
